import { createContext, useContext, useReducer } from 'react';
import dayjs from 'dayjs';
import { OfficialDiarySearchState, OfficialDiarySearchReducer, ACTION_TYPES } from './official-diary-search-reducer';
import { IOfficialDiaryPagedRequest } from '../../../../model/sdp/official-daily/request/official-diary-paged-request';
import ApplicationAppService from '../../../../application/platform/application-app-service';
import { toApiDate } from '../../../../utils/date';

const OfficialDiarySearchContext = createContext<OfficialDiarySearchState | undefined>(undefined);
const OfficialDiarySearchDispatchContext = createContext({} as any);

// Filtros padrão: últimos 30 dias; usuário de entidade já filtra pela própria entidade
export const getDefaultOfficialDiaryParameters = (): IOfficialDiaryPagedRequest => {
    const authenticationData = ApplicationAppService.getAuthenticationData();
    return {
        startDate: toApiDate(dayjs().subtract(30, 'day')) ?? undefined,
        endDate: toApiDate(dayjs()) ?? undefined,
        number: undefined,
        year: undefined,
        isClosed: undefined,
        clientId: authenticationData?.type === 1 ? authenticationData.company.id : undefined,
        page: 0,
        pageSize: 25
    } as IOfficialDiaryPagedRequest;
};

const OfficialDiarySearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: OfficialDiarySearchState = {
        parameters: getDefaultOfficialDiaryParameters(),
        searchTrigger: 0
    };

    const [state, dispatch] = useReducer(OfficialDiarySearchReducer, initialState);

    return (
        <OfficialDiarySearchContext.Provider value={state}>
            <OfficialDiarySearchDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDiarySearchDispatchContext.Provider>
        </OfficialDiarySearchContext.Provider>
    );
}

const useOfficialDiarySearchState = () => {
    const context = useContext(OfficialDiarySearchContext);
    if (context === undefined) {
        throw new Error('useOfficialDiarySearchState must be used within a OfficialDiarySearchProvider');
    }
    return context;
}

const useOfficialDiarySearchDispatch = () => {
    const context = useContext(OfficialDiarySearchDispatchContext);
    if (context === undefined) {
        throw new Error('useOfficialDiarySearchDispatch must be used within a OfficialDiarySearchProvider');
    }
    return context;
}

export { OfficialDiarySearchProvider, useOfficialDiarySearchDispatch, useOfficialDiarySearchState, ACTION_TYPES };
